import { AirHandlerProductType } from 'data/types';
import DuctedLineSetPhoto from './ducted-line-set-photo';
import DuctedLineSetProductName from './ducted-line-set-product-name';

type DuctedLineSetIndoorUnitProps = {
  product: AirHandlerProductType;
};

export default function DuctedLineSetIndoorUnit({
  product
}: DuctedLineSetIndoorUnitProps) {
  return (
    <div className='flex items-center divide-x divide-gray-200'>
      <div className='flex items-center gap-4 pr-8'>
        <DuctedLineSetPhoto product={product} />
        <div className='flex flex-col gap-1'>
          <span className='text-xs font-semibold uppercase text-gray-600'>
            Type
          </span>
          <span className='font-semibold'>{product.type ?? 'N/A'}</span>
        </div>
      </div>
      <div className='flex grow basis-0 flex-col gap-1 pl-8'>
        <span className='text-xs font-semibold uppercase text-gray-600'>
          Product
        </span>
        <DuctedLineSetProductName type='air handler' product={product} />
      </div>
    </div>
  );
}
